import { Delete } from '@mui/icons-material';
import { Typography } from '@mui/material';
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {  useLocation, useNavigate } from 'react-router-dom';
import { DATA_LIMIT } from '../../data/constants';
import { SearchVoucherBy } from '../../data/userData';
import { downloadBlobXLSFile, formatDate, getNewParameters, getObjectSubset, getParameters } from '../../lib/helper';
import { clearSingleUserDetails, userItemsSelector } from '../../redux/user';
import { deleteUser, allUserVoucherListing, allUserVoucherExportFile } from '../../Services/userApis';
import CustomButton from '../CommonComp/Buttons/CustomButton';
import ConfirmationModal from '../Modals/ConfirmationModal';
import MatTable from '../Tables/MatTable';
import { toast } from 'react-toastify';
import AllFilters from '../Order/AllFilters';
import { adminAddLogs } from '../../Services/commonService';
import { action, logsMessagesList, modulesNames } from '../../data/logsMessages';

const limit = DATA_LIMIT;

const column = [
  {
    label: 'User ID',
    id: 'user_id',
       format: (columnData) => (
        <Typography
          variant='span'
          style={{ whiteSpace: 'nowrap' }}
        >
          {columnData}
        </Typography>
    ),
  },
  {
    label: 'Order ID',
    id: 'order_id',
       format: (columnData) => (
        <Typography
          variant='span'
          style={{ whiteSpace: 'nowrap' }}
        >
          {columnData}
        </Typography>
    ),
  },
  {
    label: 'User Email',
    id: 'email',
    format: (columnData) => (<span style={{ display: 'inline-block', whiteSpace: "nowrap", wordBreak: 'break-word' }}>{columnData || 'N/A'}</span>)
  },
  {
    label: 'Voucher Email',
    id: 'voucher_email',
    format: (columnData) => (<span style={{ display: 'inline-block', whiteSpace: "nowrap", wordBreak: 'break-word' }}>{columnData || 'N/A'}</span>)
  },
  {
    label: 'Voucher Expiry',
    id: 'voucher_expiry',
    format: (columnData) => (<span style={{ display: 'inline-block', maxWidth: 200, width: "max-content" }}>{columnData || '-'}</span>)
  },
  {
    label: 'Voucher Price',
    id: 'voucher_price',
    format: (columnData) => (<span style={{ display: 'inline-block', whiteSpace: "nowrap" }}>{columnData || 'N/A'}</span>)
  },
];

function UserListByVoucher() {
  const [tableListing, setTableListing] = useState([])
  const [page, setPage] = useState(1);
  const [allParams, setAllParams] = useState(getParameters());
  const { allUserList, voucherUserDetail } = useSelector(userItemsSelector);
  const [confirmDeleteCategory, setConfirmDeleteCategory] = useState(false);
  const dispatch = useDispatch();
  const navigate = useNavigate()
  const location = useLocation();
  const [clearSelectedCheckbox, setClearSelectedCheckbox] = useState(false);
  const [deleteUserData, setDeleteUserData] = useState({});
  const [ loadings, setLoadings] = useState(false);
 
  const [filtersArray, setFiltersArray] = useState([

    {
      label: 'From Date',
      id: 'start_date',
      type: 'input',
      linkedWith: null,
      value: '',
      onChange: (e, index, value) => {
        setFiltersArray((prevState) => {
          let newState = [...prevState];
          newState[index].value = e.target.value;
          newState[1].value = e.target.value;
          return newState;
        });
      },
      style: {},
      dataArr: [],
      props: { type: 'date' },
      isVisible: true,
    },
    {
      label: 'To Date',
      id: 'end_date',
      type: 'input',
      linkedWith: null,
      value: '',
      onChange: (e, index, value) => {
        setFiltersArray((prevState) => {
          let newState = [...prevState];
          newState[index].value = e.target.value;
          return newState;
        });
      },
      style: {},
      dataArr: [],
      props: { type: 'date' },
      isVisible: true,
    },
    {
          label: 'Search By',
          id: 'search_by',
          type: 'select',
          linkedWith: null,
          value: '',
          onChange: (e, index, value) => {
            setFiltersArray((prevState) => {
              let newState = [...prevState];
              newState[index].value = e.target.value;
              return newState;
            });
          },
          style: {},
          dataArr: SearchVoucherBy,
          props: {},
          isVisible: true,
          rowFlexible:true,
          row:3
     },

    {
      label: 'Search Text',
      id: 'search',
      type: 'input',
      linkedWith: null,
      value: '',
      onChange: (e, index, value) => {
        setFiltersArray((prevState) => {
          let newState = [...prevState];
          newState[index].value = e.target.value;
          return newState;
        });
      },
      style: {},
      dataArr: [],
      props: {},
      isVisible: true,
    },


  ]);

  const getListing = async (params = {}) => {
    const payload = {
      page: String(1),
      limit: limit,
      // user_type: "2",
      ...allParams,
      ...params
    }
    if (payload?.start_date) {
      payload['start_date'] = formatDate(payload?.start_date, 'yyyy-mm-dd') + "  00:00:00"
    }
    if (payload?.end_date) {
      payload['end_date'] = formatDate(payload?.end_date, 'yyyy-mm-dd') + "  23:59:59"
    }
    dispatch(allUserVoucherListing(payload))
    setPage(Number(payload.page))
  }
  useEffect(() => {
    getListing();
  }, []);

  useEffect(() => {
    let params = getParameters()
    setAllParams(params)
  }, [location?.search]);

  useEffect(() => {
    let data = getNewParameters(allParams)
    if (data?.search !== location.search) {
      navigate(data.newUrl, { replace: false })
      if (data?.parameters?.page) {
        setPage(Number(data?.parameters?.page))
      }
    }
    getListing();
  }, [allParams])

  const handleFilter = (data, allDatavalues, dataWithValue) => {
    getListing(
      {
        page: String(1),
        ...dataWithValue,
      },
      true,
    );
    setAllParams({
      page: String(1),
      ...dataWithValue,
    });
  };

  const handleClear = () => {
    const data = getObjectSubset({ ...allParams }, 'tab', 'page');
    setAllParams(data);
    setFiltersArray((prevState) => {
      let newState = [...prevState];
      newState[0].isVisible = true;
      newState[1].isVisible = true;
      newState[2].isVisible = true;
      newState[3].isVisible = true;

      newState[0].value = '';
      newState[1].value = '';
      newState[2].value = '';
      newState[3].value = '';
      return newState;
    });
  };

  //making data format for table input
  useEffect(() => {
    if (voucherUserDetail?.items?.rows?.length >= 0) {
      let data = voucherUserDetail?.items?.rows?.map((item) => {
        return {
          order_id: item.order_id,
          user_id: item.user_id,
          email: item?.user?.email,
          voucher_expiry: item?.voucher_expiry,
          voucher_price: item?.voucher_price,
          voucher_email: item?.voucher_email,
        };
      });
      setTableListing(data)
    }
  }, [voucherUserDetail.items]);

  useEffect(()=>{
    dispatch(clearSingleUserDetails())
  },[])


  const handleBulkUpdate = async (data, resetState) => {

    let stateSelected = allUserList.items.users.filter(
      (item) => item.orders_count == false,
    );
    let userSelected = stateSelected.map(
      (item) => item.user_id,
    );
    const intersection = userSelected.filter(element => data.includes(element));
    handleCofirmModalOpen(true)
    setDeleteUserData(intersection)
  }

  const handleClearSelectedCheckbox = (value = false) => {
    setClearSelectedCheckbox(value || false)
  }

  const getExportFile = async (params = {}, prepop) => {
      try {
  
        let payload = {};  
        if (prepop?.start_date && prepop?.end_date) {
          prepop['start_date'] =
            formatDate(prepop.start_date, 'yyyy-mm-dd') + ' 00:00:00';
          prepop['end_date'] =
            formatDate(prepop.end_date, 'yyyy-mm-dd') + ' 23:59:59';
  
          payload.start_date = prepop.start_date;
          payload.end_date = prepop.end_date;
  
          let resp = await allUserVoucherExportFile(payload);
          if (resp?.status) {
            downloadBlobXLSFile(resp.data, `VoucherUserList`);
          }
        } else {
          toast.error('Start and End Date required!');
        }
      } catch (e) {
        console.log(e);
      } finally {
        setLoadings(false);
      }
    };

  const handleCofirmModalOpen = (value) => {
    setConfirmDeleteCategory(value);
  }

  const handleConfirmDeleteCategory = async (value) => {
    if (value && deleteUserData) {
      const resp = await deleteUser({ user_id: deleteUserData });
      if (resp) {
        getListing({ page: '1' })
        setPage(1)
        handleClearSelectedCheckbox(true)
      }
      let payloadForLogs = {
        action: action?.delete,
        module: modulesNames?.users,
        description: logsMessagesList?.users?.userDelete,
      };
      await adminAddLogs(payloadForLogs);
    } else {
      setDeleteUserData(null)
    }
  }

  return (
    <>
      <MatTable
        loading={voucherUserDetail?.loading}
        showCheckbox={false}
        columns={column}
        data={tableListing}
          onApplyFilter={(data = {}) => {
          getListing({
            page: String(1),
            start_date: "",
            end_date: "",
            ...getObjectSubset(data, 'start_date', 'end_date', 'identity'),
          });
          if (Object.keys(data).length > 0) {
            setAllParams({
              ...allParams,
              page: String(1),
              ...getObjectSubset(data, 'start_date', 'end_date', 'identity'),
            });
          } else {
            setAllParams({
              page: String(1),
            });
          }
        }}
        page={page}
         perPage={limit}
        total={voucherUserDetail?.items?.count || 0}
        setPage={setPage}
        handleSearch={(searchTerm) => {
          getListing({
            page: String(1),
            search: searchTerm
          })
          setAllParams({
            ...allParams,
            page: String(1),
            search: searchTerm
          })
        }}
        handlePageChange={(newPage) => {
          getListing({
            page: String(newPage)
          })
          setAllParams({
            ...allParams,
            page: String(newPage)
          })
        }}
        toolbarEnable={true}
        columnWiseData={[
          {
            id: 'user_id',
            value: handleBulkUpdate,
          }
        ]} 
        onTableToolbarRightClick={handleBulkUpdate}
        clearSelectedCheckbox={clearSelectedCheckbox}
        handleClearSelectedCheckbox={handleClearSelectedCheckbox}
        onTableToolbarRightSection={<CustomButton sx={(theme) => ({
          fontSize: '12px', whiteSpace: "nowrap", bgcolor: 'buttonSecondary.main', color: 'buttonSecondary.contrastText',
          [theme.breakpoints.down("md")]: {
            flex: 1,
          },
        })}
        >Bulk Delete</CustomButton>}
        pagination={true}
        filtersUrlData={allParams || {}}
        // filterEnable
        rangeDateFilter
        // dropdownFilter={true}
        disableSearch
        customFilter={() => (
          <AllFilters
            filtersArray={filtersArray}
            handleClick={handleFilter}
            handleClear={handleClear}
            hasDownloadExcelButton={true}
            handleDownloadExcel={getExportFile}
          />
        )}
      />
      {confirmDeleteCategory && <ConfirmationModal open={confirmDeleteCategory} handleConfirm={handleConfirmDeleteCategory} setOpen={handleCofirmModalOpen} />}
    </>
  );
}

export default UserListByVoucher;
